import PropTypes from 'prop-types';
import React from 'react';
import Close from "../../icon-components/close";

var UndoLink = function UndoLink(_ref) {
  var handleUndoChanges = _ref.handleUndoChanges,
      handleNotificationClose = _ref.handleNotificationClose,
      movedCountriesNumber = _ref.movedCountriesNumber,
      formatMessage = _ref.formatMessage,
      messages = _ref.messages;
  return React.createElement("div", {
    className: "UndoLink"
  }, React.createElement("span", null, React.createElement("span", null, "".concat(movedCountriesNumber, " ").concat(formatMessage(messages.undoDescription))), React.createElement("span", {
    className: "UndoLink-link btn btn-link",
    onClick: handleUndoChanges
  }, formatMessage(messages.undoLabel))), React.createElement(Close, {
    onClick: handleNotificationClose
  }));
};

UndoLink.propTypes = {
  movedCountriesNumber: PropTypes.number,
  handleUndoChanges: PropTypes.func,
  handleNotificationClose: PropTypes.func,
  formatMessage: PropTypes.func.isRequired,
  messages: PropTypes.object.isRequired
};
export default UndoLink;